import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the FormatBonusPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatBonus',
})
export class FormatBonusPipe implements PipeTransform {
  /**
   * Takes a job and returns the bonus in a human readable format for job cards
   */
  transform(job: any, ...args) {
    if (job.bonusOffer === 'yes') {
      if (_.get(job, 'bonusDetails.length')) {
        return _.get(job, 'bonusDetails');
      } else {
        return 'Yes';
      }
    } else if (job.bonusOffer === 'no') {
      return 'No';
    } else if (job.bonusOffer === 'calltodiscuss') {
      return 'Call to Discuss';
    } else {
      return 'Call to Discuss';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-bonus/format-bonus.ts